import { css } from '@emotion/react';
import { type FC } from 'react';
import { ExportImageMode } from '~/_shared/types/exportImage/exportImage';
import { homePageZIndexes } from '~/homepage/homepage.constants';
import { useMapSettingsExportImageSettingsSelector } from '~/store/mapSettings/toolsState/exportImageSettings/exportImageSettings.selectors';

const PADDING = 10;

const leftSidebarStyle = ({ isFloating }: { isFloating: boolean }) => css({
  position: isFloating ? 'absolute' : 'relative',
  left: isFloating ? PADDING : 0,
  top: isFloating ? PADDING : 0,
  flexShrink: 0,
  height: isFloating ? 'auto' : '100%',
  borderRadius: isFloating ? 10 : 0,
  overflow: isFloating ? 'hidden' : 'visible',
  zIndex: homePageZIndexes.leftSidebar,
  maxHeight: isFloating ? `calc(100% - ${PADDING * 2}px)` : '100%',
});

export const LeftSidebar: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const isLegendOverMapMode = useMapSettingsExportImageSettingsSelector()?.mode === ExportImageMode.MapAndLegend;

  return (
    <div
      data-testid="sidebar"
      css={leftSidebarStyle({ isFloating: isLegendOverMapMode })}
    >
      {children}
    </div>
  );
};
